import FilterField from './FilterField';
import { defaultFilterValue } from '../../utils/studentFilterParams';
import { FILTER_CATEGORY_LABELS } from '../../domain/filters/filterProfiles';

/**
 * One collapsible filter group. Starts closed; parent owns expanded state.
 */
const FilterCategorySection = ({
  category,
  fields,
  expanded,
  onToggle,
  filters,
  onChange,
  onFieldFocus,
  loading,
  loadingOptions,
  fieldOptions,
  compact = false,
}) => (
  <div
    className="border rounded-lg overflow-hidden"
    style={{
      borderColor: 'var(--color-border)',
      backgroundColor: 'var(--color-surface)',
    }}
  >
    <button
      type="button"
      onClick={() => onToggle(category)}
      className="w-full px-4 py-3 flex items-center justify-between hover:bg-opacity-50 transition-colors"
      style={{ backgroundColor: 'var(--color-surface-secondary)' }}
    >
      <span className="font-semibold" style={{ color: 'var(--color-text)' }}>
        {FILTER_CATEGORY_LABELS[category] || category}
      </span>
      <span className="text-lg" style={{ color: 'var(--color-text-secondary)' }}>
        {expanded ? '▼' : '▶'}
      </span>
    </button>

    {expanded && (
      <div className="p-4">
        <div
          className={
            compact
              ? 'grid grid-cols-1 gap-3'
              : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'
          }
        >
          {fields.map((field) => (
            <FilterField
              key={field.name}
              field={{
                ...field,
                options: fieldOptions[field.name] || field.options || [],
              }}
              value={filters[field.name] ?? defaultFilterValue(field)}
              onChange={onChange}
              onFocus={() => onFieldFocus(field.name)}
              loading={loading}
              isLoading={loadingOptions[field.name]}
            />
          ))}
        </div>
      </div>
    )}
  </div>
);

export default FilterCategorySection;
